import { render, staticRenderFns } from "./devolucionesLeecheros.vue?vue&type=template&id=1f8f0f8a&scoped=true&"
import script from "./devolucionesLeecheros.vue?vue&type=script&lang=js&"
export * from "./devolucionesLeecheros.vue?vue&type=script&lang=js&"
import style0 from "./devolucionesLeecheros.vue?vue&type=style&index=0&id=1f8f0f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f0f8a",
  null
  
)

export default component.exports